import { clearFilters } from "../../../store/slices/menuItemSlice";

export const arCommonTranslations = {
	common: {
		clearFilters: 'مسح المرشحات',
		login: 'تسجيل الدخول',
		unpublish: 'إلغاء النشر',
		logout: 'تسجيل الخروج',
		getStarted: 'البدء',
		previous: 'السابق',
		next: 'التالي',
		slide: 'شريحة',
		lightMode: 'الوضع الفاتح',
		darkMode: 'الوضع الداكن',
		loading: 'جارٍ التحميل...',
		error: 'حدث خطأ',
		retry: 'إعادة المحاولة',
		save: 'حفظ',
		cancel: 'إلغاء',
		delete: 'حذف',
		edit: 'تعديل',
		view: 'عرض',
		create: 'إنشاء',
		update: 'تحديث',
		close: 'إغلاق',
		and: 'و',
		english: 'English',
		arabic: 'العربية',
		language: 'اللغة',
		currency: 'العملة',
		filter: 'تصفية',
		export: 'تصدير',

		hideFilters: 'إخفاء المرشحات',
		showFilters: 'إظهار المرشحات',
		backToOrders: 'العودة إلى الطلبات',
		all: 'الكل',
		search: 'بحث',
		showing: 'عرض',
		total: 'الإجمالي',
		of: 'من',
		uploadFile: 'رفع ملف',
		dragAndDrop: 'سحب وإفلات',
		expand: 'توسيع',
		collapse: 'طي',
		ingredientName: 'اسم المكون',
		enterIngredientName: 'أدخل اسم المكون',
		arabicName: 'الاسم بالعربية (اختياري)',
		enterArabicName: 'أدخل اسم المكون بالعربية',
		groupName: 'اسم المجموعة',
		enterGroupName: 'أدخل اسم المجموعة',
		selectIngredients: 'اختر المكونات',
		noIngredientsFound: 'لم يتم العثور على مكونات',
		noGroupsFound: 'لم يتم العثور على مجموعات',
		noIngredientsAvailable: 'لا توجد مكونات متاحة. يرجى إنشاء بعض المكونات أولاً.',
		tryAdjustingSearch: 'حاول تعديل معايير البحث',
		startByAddingFirst: 'ابدأ بإضافة أول مكون لك',
		startByCreatingFirst: 'ابدأ بإنشاء أول مجموعة مكونات لك',
		searchGroups: 'ابحث عن المجموعات...',
		ingredients: 'المكونات',
		deleteIngredientConfirm: 'هل أنت متأكد من رغبتك في حذف هذا المكون؟ لا يمكن التراجع عن هذا الإجراء.',
		deleteGroupConfirm: 'هل أنت متأكد من رغبتك في حذف هذه المجموعة؟ سيؤدي هذا أيضاً إلى إزالة جميع العلاقات بين المكونات في هذه المجموعة.',

		saving: "جارٍ الحفظ...",
		dashboard: "لوحة التحكم",

		success: 'نجاح',
		notification: 'إشعار',
		dismiss: 'إغلاق',
		actions: 'إجراءات',
		reset: 'إعادة تعيين',
		trigger: 'المحفز',
		suggested: 'المقترح',

		pagination: {
			showing: 'عرض {{start}} إلى {{end}} من {{total}} نتيجة',
			previous: 'السابق',
			next: 'التالي',
			page: 'صفحة',
			of: 'من',
			goToPage: 'انتقل إلى الصفحة {{page}}',
			itemsPerPage: 'عناصر لكل صفحة'
		},
		ingredientManagement: {
			title: 'إدارة المكونات',
			selectedIngredients: 'المكونات المختارة',
			selectedGroups: 'المجموعات المختارة',
			ingredientsAndGroups: 'المكونات والمجموعات',
			searchIngredients: 'البحث عن المكونات والمجموعات...',
			noItemsSelected: 'لم يتم اختيار أي عناصر بعد. انقر على زر + لإضافة المكونات أو المجموعات.',
			ingredients: 'مكونات',
			noResults: 'لا توجد {{type}} تطابق "{{term}}"',
			noAvailable: 'لا توجد {{type}} متاحة للإضافة'
		},
		variants: {
			dynamicOptions: 'الخيارات الديناميكية',
			variantsSelected: 'متغيرات مختارة',
			noVariantsConfigured: 'لا توجد متغيرات مكونة',
			configureVariantsInSettings: 'قم بتكوين المتغيرات في إعدادات الفرع لتمكين الخيارات الديناميكية لهذا العنصر.',
			noOptionsConfigured: 'لا توجد خيارات مكونة لهذا المتغير',
			noComboConfigured: 'لا يوجد تكوين مجموعة متاح',
			default: 'افتراضي',
			price: 'السعر',
			note: 'ملاحظة',
			status: 'الحالة',
			active: 'نشط',
			inactive: 'غير نشط',
			addToItem: 'إضافة للعنصر',
			removeFromItem: 'إزالة من العنصر',
			required: 'مطلوب',
			optional: 'اختياري',
			selections: 'اختيارات',
			comboPrice: 'سعر المجموعة',
			comboItems: 'عناصر المجموعة',
			multiselection: 'اختيار متعدد',
			selectionRange: 'نطاق الاختيار',
			optionsCount: 'عدد الخيارات',
			comboData: 'بيانات الكومبو',
			formName: 'اسم النموذج',
			actionType: 'نوع الإجراء',
			minSelection: 'أقل عدد اختيار',
			maxSelection: 'أكثر عدد اختيار',
			selectionOptions: 'خيارات الاختيار',
			addOption: 'إضافة خيار',
			option: 'خيار',
			optionName: 'اسم الخيار',
			comboConfiguration: 'تكوين الكومبو',
			addItem: 'إضافة عنصر',
			item: 'عنصر',
			itemName: 'اسم العنصر',
			quantity: 'الكمية',
			basicInfo: 'المعلومات الأساسية',
			basicInfoDesc: 'تحديد اسم المتغير ونوعه',
			configuration: 'التكوين',
			configurationDesc: 'تكوين قواعد الاختيار والمتطلبات',
			selectionRules: 'قواعد الاختيار',
			selectionLimits: 'حدود الاختيار',
			formNamePlaceholder: 'مثال: خيارات الحجم، اختيار المشروب',
			optionNamePlaceholder: 'مثال: كبير، متوسط',
			notePlaceholder: 'ملاحظة اختيارية',
			itemNamePlaceholder: 'مثال: برجر، بطاطس',
			selectionOptionsDesc: 'إضافة الخيارات المتاحة للعملاء للاختيار منها',
			comboConfigDesc: 'تكوين عناصر الكومبو والتسعير',
			noOptionsAdded: 'لم يتم إضافة خيارات بعد. انقر على "إضافة خيار" للبدء.',
			noItemsAdded: 'لم يتم إضافة عناصر بعد. انقر على "إضافة عنصر" للبدء.',
			editDescription: 'تعديل تكوين المتغير',
			createDescription: 'إنشاء تكوين متغير جديد لعناصر القائمة',
			formNameRequired: 'اسم النموذج مطلوب',
			actionTypeRequired: 'نوع الإجراء مطلوب',
			minSelectionInvalid: 'يجب أن يكون الحد الأدنى للاختيار 0 أو أكبر',
			maxSelectionInvalid: 'يجب أن يكون الحد الأقصى للاختيار أكبر من أو يساوي الحد الأدنى',
			optionsRequired: 'مطلوب خيار واحد على الأقل',
			settings: 'الإعدادات',
			requiredDescription: 'يجب على العميل اختيار هذا المتغير',
			multiselectionDescription: 'السماح باختيار خيارات متعددة',
			description: 'الوصف (اختياري)',
			descriptionPlaceholder: 'أضف وصف (اختياري)',
			noteAr: 'ملاحظة بالعربية',
			noteArPlaceholder: 'أضف ملاحظة (اختياري)',
			descriptionAr: 'وصف بالعربية',
			descriptionArPlaceholder: 'أضف وصف (اختياري)',
			activeVariantsSummary: 'المتغيرات النشطة على هذا العنصر',
			management: {
				title: 'إدارة المتغيرات',
				description: 'إدارة تكوينات المتغيرات لهذا الفرع',
				addVariant: 'إضافة متغير',
				editVariant: 'تعديل المتغير',
				noVariants: 'لم يتم تكوين متغيرات',
				noVariantsDescription: 'ابدأ بإنشاء أول تكوين متغير',
				createFirst: 'إنشاء أول متغير',
				deleteTitle: 'حذف المتغير',
				deleteDescription: 'هل أنت متأكد من حذف "{{name}}"؟ هذا الإجراء لا يمكن التراجع عنه.',
				searchPlaceholder: 'البحث في المتغيرات...',
				totalVariants: 'إجمالي المتغيرات',
				showing: 'عرض',
				allTypes: 'جميع الأنواع',
				noResults: 'لا توجد نتائج',
				noResultsDescription: 'جرب تعديل معايير البحث أو المرشحات',
				options: 'الخيارات',
				addComboItem: 'إضافة عنصر كومبو',
				optionalPrice: 'سعر اختياري'
			},
			comboOrOptionsRequired: 'إما عناصر الكومبو أو خيارات الترقية مطلوبة',
			invalidExistingSelection: 'عنصر كومبو واحد أو أكثر يتطلب تحديد عنصر قائمة أو التبديل إلى اسم مخصص',
			selectMenuItem: 'تحديد عنصر القائمة',
			searchMenuItems: 'البحث في عناصر القائمة...',
			requiredNeedsDefault: 'يجب أن تحتوي النماذج المطلوبة على خيار افتراضي واحد على الأقل',
			formNameSection: 'اسم النموذج',
			formNameAr: 'اسم النموذج بالعربية',
			formNameArPlaceholder: 'أدخل اسم النموذج بالعربية',
			priceDefaultPlaceholder: '0.00',
			optionNameAr: 'الاسم بالعربية',
			optionNameArPlaceholder: 'أدخل اسم الخيار',
			newOption: 'خيار جديد',
		},
		currencies: {
		title: 'العملات',
		subtitle: 'إدارة عملات الفرع ومعدلات الصرف',
		addCurrency: 'إضافة عملة',
		editCurrency: 'تعديل العملة',
		currencyName: 'اسم العملة',
		currencyCode: 'رمز ISO',
		currencySymbol: 'رمز العملة',
		exchangeRate: 'سعر الصرف',
		baseCurrency: 'العملة الأساسية',
		setAsBase: 'تعيين كعملة أساسية',
		noCurrencies: 'لم تتم إضافة أي عملات حتى الآن',
		addSuccess: 'تمت إضافة العملة بنجاح',
		updateSuccess: 'تم تحديث العملة بنجاح',
		deleteSuccess: 'تم حذف العملة بنجاح',
		addError: 'فشل إضافة العملة',
		updateError: 'فشل تحديث العملة',
		deleteError: 'فشل حذف العملة',
		deleteCurrency: 'حذف العملة',
		deleteConfirmation: 'هل أنت متأكد من رغبتك في حذف هذه العملة؟ لا يمكن التراجع عن هذا الإجراء.',
		precision: 'دقة الكسور العشرية',
	},
	notifications: {
		loginSuccess: 'تم تسجيل الدخول بنجاح',
		registerSuccess: 'تم إنشاء الحساب بنجاح',
		organizationCreated: 'تم إنشاء المؤسسة بنجاح',
		organizationUpdated: 'تم تحديث المؤسسة بنجاح',
		branchCreated: 'تم إنشاء الفرع بنجاح',
		branchUpdated: 'تم تحديث الفرع بنجاح',
		branchDeleted: 'تم حذف الفرع بنجاح',
		categoryCreated: 'تم إنشاء الفئة بنجاح',
		categoryUpdated: 'تم تحديث الفئة بنجاح',
		categoryDeleted: 'تم حذف الفئة بنجاح',
		menuItemCreated: 'تم إنشاء عنصر القائمة بنجاح',
		menuItemUpdated: 'تم تحديث عنصر القائمة بنجاح',
		menuItemDeleted: 'تم حذف عنصر القائمة بنجاح',
		unexpectedError: 'حدث خطأ غير متوقع'
	}
}
}